export default "__VITE_ASSET__zDPHvzsa__"